import styled, { css } from "styled-components";

export const CountDownBox = styled.div`
	display: flex;
	height: 21px;
	background: rgba(0, 0, 0, 0.4);
	gap: 6px;

	width: 100%;
	position: absolute;
	bottom: 0;
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const Time = styled.div`
	height: 16px;
	font-size: 12px;
	font-weight: 500;
	color: #ffffff;
	line-height: 16px;
`;

export const CountDIcon = styled.i.withConfig({
	shouldForwardProp: (prop) => !["height"].includes(prop),
})<{ height?: string }>`
	font-size: 12px;
	color: white;

	${(props: { height?: string }) => {
		if (props.height) {
			return css`
				height: ${props.height};
			`;
		}
		return "";
	}}
`;
